<template>
    <BasePanel
        :headline="$t('lang_LABEL_RELEASES') + ' (' + listItemsLength + ')'"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="listItems"
                hide-default-footer
                must-sort
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :custom-sort="sortReleases"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
                :items-per-page="-1"
            >
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

                <template v-slot:[`item.alvId`]="{ item }">
                    <div class="ellipsis">
                        <BaseTooltip
                            :simpleText="item.alvId || ''"
                            :alvqa="alvqa + '-list-row-text-alvid'"
                        />
                    </div>
                </template>
                <template v-slot:[`item.title`]="{ item }">
                    <div class="ellipsis">
                        <BaseTooltip
                            :simpleText="item.title || ''"
                            :alvqa="alvqa + '-list-row-text-release-title'"
                        />
                    </div>
                </template>
                <template v-slot:[`item.displayArtist`]="{ item }">
                    <div class="ellipsis">
                        <BaseTooltip
                            :simpleText="item.displayArtist || ''"
                            :alvqa="alvqa + '-list-row-text-display-artist'"
                        />
                    </div>
                </template>
                <template v-slot:[`item.tracks`]="{ item }">
                    <div
                        class="text-right"
                        :alvqa="alvqa + '-list-row-text-tracks'"
                    >
                        {{ item.tracks }}
                    </div>
                </template>
                <template v-slot:[`item.ean`]="{ item }">
                    <div class="ellipsis">
                        <BaseTooltip
                            :simpleText="item.ean || ''"
                            :alvqa="alvqa + '-list-row-text-ean'"
                        />
                    </div>
                </template>
                <template v-slot:[`item.catalogueNumber`]="{ item }">
                    <div class="ellipsis">
                        <BaseTooltip
                            :simpleText="item.catalogueNumber || ''"
                            :alvqa="alvqa + '-list-row-text-catalogue-number'"
                        />
                    </div>
                </template>
                <template v-slot:[`item.dateRetail`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-date-retail'">
                        {{ formatReleaseDate(item.dateRetail) }}
                    </div>
                </template>
                <template v-slot:[`item.dateDigital`]="{ item }">
                    <div :alvqa="alvqa + '-list-row-text-date-digital'">
                        {{ formatReleaseDate(item.dateDigital) }}
                    </div>
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import BaseTooltip from '@/components/_base/BaseTooltip'

export default {
    name: 'AzPersonsReleasesReadOnlyPanel',
    components: {
        BasePanel,
        BaseTooltip,
    },
    props: {
        azPersonsAlvId: {
            type: String
        }
    },
    data() {
        return {
            alvqa: 'az-persons-list-row-' + this.azPersonsAlvId + '-read-only-panel-releases',
            sortBy: 'tracks',
            sortDesc: true,
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$t('lang_GENERIC_CAPTION_ALVID'),
                    value: 'alvId',
                    align: 'left',
                    sortable: false,
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-header-alvid'
                },
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_TITLE'),
                    value: 'title',
                    align: 'left',
                    sortable: true,
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-header-title'
                },
                {
                    text: this.$t('lang_LABEL_RELEASE_CAPTION_DISPLAY_ARTIST'),
                    value: 'displayArtist',
                    align: 'left',
                    sortable: true,
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-header-display-artist'
                },
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_NUMBER_OF_TRACKS'),
                    value: 'tracks',
                    align: 'end',
                    sortable: true,
                    width: '100px',
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-header-tracks'
                },
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_EAN_UPC'),
                    value: 'ean',
                    align: 'left',
                    sortable: false,
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-header-ean'
                },
                {
                    text: this.$t('lang_LABEL_RELEASE_CAPTION_CATALOGUE_NUMBER'),
                    value: 'catalogueNumber',
                    align: 'left',
                    sortable: true,
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-header-catalogue-number'
                },
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_DATE_PHYSICAL'),
                    value: 'dateRetail',
                    align: 'left',
                    sortable: true,
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-header-date-retail'
                },
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_DATE_DIGITAL'),
                    value: 'dateDigital',
                    align: 'left',
                    sortable: true,
                    class: 'text-no-wrap',
                    alvqa: this.alvqa + '-header-date-digital'
                },
            ]
        },
        listItems() { return this.$store.getters.getAzPersonsReleases },
        listItemsLength() { return this.listItems.length }
    },
    methods: {
        formatReleaseDate(value) {
            if (value === null || value === undefined || value === '') return ''
            return this.$d(new Date(value), 'alvDateFormat')
        },
        sortReleases(items, sortBy, sortDesc) {
            const key = Array.isArray(sortBy) ? sortBy[0] : sortBy
            const desc = Array.isArray(sortDesc) ? !!sortDesc[0] : !!sortDesc
            if (!key || !items) return items
            return items.slice().sort((a, b) => {
                const primary = this.compareReleaseValues(a, b, key, desc)
                if (primary !== 0 || key !== 'tracks') return primary
                return this.compareReleaseValues(a, b, 'title', false)
            })
        },
        compareReleaseValues(a, b, key, desc) {
            if (key === 'tracks') return this.compareNumber(a.tracks, b.tracks, desc)
            if (key === 'dateRetail' || key === 'dateDigital') return this.compareDate(a[key], b[key], desc)
            return this.compareText(a[key], b[key], desc)
        },
        isEmptySortValue(value) {
            return value === null || value === undefined || value === ''
        },
        compareNumber(a, b, desc) {
            const emptyA = this.isEmptySortValue(a) || Number.isNaN(Number(a))
            const emptyB = this.isEmptySortValue(b) || Number.isNaN(Number(b))
            if (emptyA && emptyB) return 0
            if (emptyA) return 1
            if (emptyB) return -1
            const diff = Number(a) - Number(b)
            return desc ? -diff : diff
        },
        compareDate(a, b, desc) {
            const timeA = new Date(a).getTime()
            const timeB = new Date(b).getTime()
            const emptyA = this.isEmptySortValue(a) || Number.isNaN(timeA)
            const emptyB = this.isEmptySortValue(b) || Number.isNaN(timeB)
            if (emptyA && emptyB) return 0
            if (emptyA) return 1
            if (emptyB) return -1
            const diff = timeA - timeB
            return desc ? -diff : diff
        },
        compareText(a, b, desc) {
            const emptyA = this.isEmptySortValue(a)
            const emptyB = this.isEmptySortValue(b)
            if (emptyA && emptyB) return 0
            if (emptyA) return 1
            if (emptyB) return -1
            const diff = String(a).localeCompare(String(b), undefined, { sensitivity: 'base', numeric: true })
            return desc ? -diff : diff
        },
    }
}
</script>

<style>
.noMinWidth table {
    min-width: 0px !important;
    table-layout: fixed;
}
</style>
